"use client";
import dynamic from "next/dynamic";
import { memo } from "react";

const EditorTinymce = dynamic(() => import("./EditorTinymce"), {
  ssr: false,
});

const index = ({
  initialValue,
  onChange,
  otherFieldProps,
}: {
  initialValue?: string;
  onChange: (value: string) => void;
  otherFieldProps?: object;
}) => {
  return (
    <>
      <EditorTinymce
        initialValue={initialValue}
        onChange={onChange}
        otherFieldProps={otherFieldProps}
      />
    </>
  );
};

export default memo(index);
